import { render, staticRenderFns } from "./amountlogs.vue?vue&type=template&id=38061f07&"
import script from "./amountlogs.vue?vue&type=script&lang=js&"
export * from "./amountlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports